module.exports = __webpack_public_path__ + "static/img/4911_phase_function_Paper_Points.79efd1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4911_phase_function_Paper_Points.png
// module id = n+/c
// module chunks = 0